<template>
  <v-card flat>
    <v-card-title class="subtitle-1 pa-0 ma-0">
      <span>{{ value.titulo }}</span>
      <v-switch
        v-model="value.habilitado"
        color="secondary"
        class="ml-4"
        dense
      />
    </v-card-title>
    <v-card-text
      v-show="value.habilitado"
      class="pa-0 ma-0"
    >
      <v-card flat>
        <v-card-title class="subtitle-1 pa-0 ma-0">
          <v-icon class="mr-2">
            access_time
          </v-icon>
          <v-text-field
            v-model="value.anos"
            style="max-width: 48px"
            type="number"
            :min="0"
            @blur="validate('anos', value.anos)"
          />
          <span class="ml-1 mr-4">ano(s) e</span>
          <v-text-field
            v-model="value.meses"
            style="max-width: 48px"
            type="number"
            :min="0"
            :max="11"
            @blur="validate('meses', value.meses)"
          />
          <span class="ml-1">mês(es)</span>
        </v-card-title>
      </v-card>
      <slot name="children" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FiltroTime',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        habilitado: true,
        anos: 0,
        meses: 0,
      }),
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    'value.habilitado': function (value) {
      if (!value) {
        this.setDefault();
      }
    },
    disable(value) {
      if (value) {
        this.value.habilitado = false;
      }
    },
  },

  methods: {
    setDefault() {
      this.value.anos = 0;
      this.value.meses = 0;
    },
    validate(tipo, value) {
      if (!parseInt(value, 10) || value < 0) {
        this.value[tipo] = 0;
      } else if (tipo === 'meses' && value > 11) {
        this.value[tipo] = 11;
      }
    },
  },
};
</script>
